import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";
import { useWorkspace } from "../useWorkspace";

export type SasResponse = {
    sasUri: string;
    fileId: string;
    workspaceId: string
}

export function useReadSas(workspaceId: string, fileId: string, baseUrl?: string): UseQueryResult<string, unknown> {

    const workspace = useWorkspace(workspaceId);
    const apiEndpoint = workspace.data?.config?.filestoreConfig?.apiEndpoint;

    return useQuery({
        queryKey: ["getFileSasUrl", fileId, baseUrl],
        queryFn: async () => {
            const url = `${apiEndpoint}/file/${fileId}/sas`;
            const res = await axiosBeyonClient?.get<SasResponse>(url);
            return res.data.sasUri;
        },
        enabled: !!apiEndpoint,
        refetchOnWindowFocus: false,
    });
}
